import React from 'react';
import Link from './link';
import classNames from 'classnames';
import Header from './header';

const TriangleBubbles = ({hashtagsBackgroundColor, borderRadius, hashtagsSection }) => {
  // Function to generate an array of n bubbles
  const handleChildClick = (e) => {
    // This stops the click event from reaching the parent
    e.stopPropagation();
  }

  // Function to generate bubbles
  const generateBubbles = (tags) => {
    return tags.map((tag, index) => (
      <Link
        key={index}
        className={classNames("tags-color tags-color--normal")}
        to={`/de/tags/${tag.tag}/`}
        title={tag.tag}
        onClick={handleChildClick}
        style={{ backgroundColor: hashtagsBackgroundColor }}
      >
        {`#${tag.tag}`}
      </Link>
    ));
  };

  // Function to generate rows of bubbles
const generateRows = () => {
    const rows = [];
    let remainingTags = [...hashtagsSection.tags]; // Create a copy of the tags array
    const numBubblesInRows = [6, 4, 3, 2, 1]; // Number of bubbles in each row
    numBubblesInRows.forEach(numBubbles => {
      const rowStyle = {
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap'
      };
      const rowTags = remainingTags.splice(0, numBubbles);
      const row = (
        <div key={numBubbles} style={rowStyle}>
          {generateBubbles(rowTags)}
        </div>
      );
      rows.push(row);
    });
    return rows;
  };

  return (
    <>
      <Header  heading={hashtagsSection?.heading}/>
      <div className="container">
        <div className="row">
          <div className="col">
            <div className="triangle-container">
              {generateRows()}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TriangleBubbles;
